.container {
  display: flex;
  width: 100rem;
  min-height: 0;
  max-width: 100%;
  height: 88rem;
  max-height: 90vh;
  border-radius: 4px;

  @media screen and (min-width: $bp-medium) {
    /* the ui-kit dialog clamps its content to 85vh with 1.6rem padding around
       this container (dialog.module.scss) — stay within that clamp so the
       panel footers are never pushed below the viewport */
    max-height: calc(85vh - 4rem);
  }
}

.left-container {
  display: flex;
  flex-direction: column;
  flex-basis: 0;
  flex-grow: 11;
  max-height: 100%;
  max-width: 55%;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;

  @media screen and (max-width: #{$bp-medium - 1}) {
    max-width: 100%;

    &[data-active='false'] {
      display: none;
    }
  }
}

.left-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  padding: 0 2.4rem 2.4rem;
  gap: 1.6rem;

  @media screen and (min-width: $bp-medium) {
    header > div {
      display: none;
    }
  }
}

.right-container {
  display: flex;
  flex-direction: column;
  flex-basis: 0;
  flex-grow: 9;
  background: var(--color-grayscale-eerie-black, #181a1e);
  max-width: 45%;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;

  @media screen and (max-width: #{$bp-medium - 1}) {
    max-width: 100%;

    &[data-active='false'] {
      display: none;
    }
  }
}

.added-candidates-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  overflow-y: auto;
  gap: 1.6rem;
}

.title {
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #7e8087;
}

.member {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3.2rem;
  gap: 1.6rem;
  width: 100%;
  cursor: default;

  &[data-is-assigned='true'] {
    cursor: default;
  }
}

.text-wrapper {
  display: flex;
  align-items: center;
  gap: 1.6rem;
  max-width: 100%;
  min-width: 0;
}

.invite {
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 1.8rem;
  color: var(--color-secondary);
  border-radius: 0.4rem;
  transition: background-color 0.1s ease-in-out;
  padding: 0.2rem 0.6rem;

  & svg {
    width: 1rem;
    height: 1rem;
    fill: var(--color-grey-5);
    stroke: var(--color-grey-5);
  }

  &:hover {
    cursor: pointer;
    background-color: var(--color-secondary-10);

    &[data-is-assigned='true'] {
      cursor: default;
      background-color: transparent;
    }
  }
}

.name {
  font-family: 'Inter';
  font-weight: 500;
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #ffffff;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.close-button-wrapper {
  align-self: flex-end;
  /* keep the action reachable even when the panel content overflows the
     dialog's scroll area on very short viewports */
  position: sticky;
  bottom: 0;

  @media screen and (max-width: #{$bp-medium - 1}) {
    display: none;
  }
}

.create-contact-link-wrapper {
  background: var(--color-grayscale-eerie-black, #181a1e);
  display: flex;
  padding: 2.4rem 2.4rem 3.2rem;
  justify-content: space-between;
  align-items: center;

  @media screen and (min-width: $bp-medium) {
    display: none;
  }

  span:first-child {
    color: var(--color-grayscale-white, #fafafa);
    font-size: 1.8rem;
    font-weight: 600;
  }
}

.left-header {
  @media screen and (min-width: $bp-medium) {
    .close-item {
      display: none;
    }
  }
}

.added-contacts-section {
  display: none;
  gap: 1.6rem;
  flex: 1;

  @media screen and (min-width: $bp-small) {
    display: flex;
    flex-direction: column;
    min-height: 0;
  }
}
